import { createRoutine } from 'redux-saga-routines';
import { GET_ARTISTS, GET_PROFILE_REPERTOIRE } from './constants';

export const getArtistsAction = createRoutine(GET_ARTISTS);
export const getProfileRepertoireAction = createRoutine(GET_PROFILE_REPERTOIRE);
